<template>
  <div>
    <base-button
      class="rounded-full z-10 mt-5 hover:cursor-pointer shadow border border-sh-primary"
      color="white"
      @click.native="toggleMenu"
    >
      <base-icon fill="#0082d5" name="eye" />
    </base-button>
    <ul
      v-show="showMenu"
      ref="menu"
      class="menu"
      :style="menuPosition"
      @click="toggleMenu"
    >
      <li class="mobile-only">
        <a
          href="javascript:void(0)"
          class="block w-full h-full"
          @click.prevent="toggleFullscreen"
        >
          <span v-if="!isFullscreen">{{ $t('visualAid.enableFulscreen') }}</span
          ><span v-else>{{ $t('visualAid.disableFulscreen') }}</span></a
        >
      </li>
      <li>
        <a
          href="javascript:void(0)"
          class="block w-full h-full"
          @click.prevent="toggleGrid"
          ><span v-if="!showGrid">{{ $t('visualAid.showGrid') }}</span
          ><span v-else>{{ $t('visualAid.hideGrid') }}</span></a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    elementsToHide: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    isFullscreen: false,
    showMenu: false,
    showGrid: false,
    menuPosition: { left: 0 }
  }),
  methods: {
    toggleGrid() {
      this.showGrid = !this.showGrid;
      this.$emit('toggleGrid', this.showGrid);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
      if (this.showMenu) {
        this.$nextTick(() => {
          // Ensure the menu is positioned correctly and not cut off
          const menuWidth = this.$refs.menu.offsetWidth;
          this.menuPosition.left = `calc(-${menuWidth}px + 80px)`;
        });
      }
    },
    toggleFullscreen() {
      this.elementsToHide.forEach(selector => {
        const element = document.querySelector(selector);
        if (!element) return;

        if (this.isFullscreen) {
          element.style.display = element.dataset.creatorDisplayState || '';
          element.removeAttribute('data-creator-display-state');
        } else {
          element.dataset.creatorDisplayState =
            getComputedStyle(element).display;
          element.style.display = 'none';
        }
      });
      this.isFullscreen = !this.isFullscreen;
    }
  }
};
</script>

<style scoped>
.mobile-only {
  display: none;
}
@screen xs {
  .mobile-only {
    display: inherit;
  }
}
button {
  width: 50px;
  height: 50px;
}
.menu {
  @apply absolute bg-white shadow-lg rounded-lg p-0 m-0;
  list-style: none;
}
.menu a {
  @apply block w-full h-full no-underline px-3 py-2 whitespace-no-wrap;
}
.menu a:hover {
  @apply bg-grey-light;
}
</style>
